import { render, staticRenderFns } from "./DomainForwardingCreateSubscription.vue?vue&type=template&id=54e3eece&scoped=true"
import script from "./DomainForwardingCreateSubscription.vue?vue&type=script&lang=js"
export * from "./DomainForwardingCreateSubscription.vue?vue&type=script&lang=js"
import style0 from "./DomainForwardingCreateSubscription.vue?vue&type=style&index=0&id=54e3eece&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e3eece",
  null
  
)

export default component.exports